import { useSelector } from 'react-redux';

import { selectGeneralSettings } from '../services/selectors';

export const useSubscriptionType = () => {
    const { subscription } = useSelector(selectGeneralSettings);

    return subscription;
};
